import logoImg from "../assets/images/logo.svg"
import copySimbol from "../assets/images/copy.svg"
import { Button } from "../components/Button";
import "../styles/rooms.scss"
import { useParams } from "react-router-dom";
import { FormEvent, useContext, useState } from "react";
import { AuthContext } from "../App";
import { database } from "../services/Firebase";
import { push, ref } from "firebase/database";
import { Questions } from "../components/Questions";
import { useRoom } from "../hooks/useRoom";

type typeParams = {
    id: string;
}

export function Room() {
    const params = useParams<typeParams>();
    const { user } = useContext(AuthContext);
    const [newQuestion, setNewQuestion] = useState("");
    const roomId = params.id!;
    const { questions, title, numberOfQuestions } = useRoom(roomId);

    function copyRoomCodeToClipboard() {
        navigator.clipboard.writeText(params.id!);
        alert("copied");
    }

    async function handleNewQuestion(event: FormEvent) {
        event.preventDefault();

        if(newQuestion.trim() === "") {
            return;
        }

        if(!user) {
            throw new Error("You must be logged in!");
        }

        const question = {
            content: newQuestion,
            author: {
                name: user.name,
                avatar: user.avatar,
            },
            isHighLighted: false,
            isAnsweared: false,
        }

        await push(ref(database, `rooms/${params.id}/questions`), question);

        setNewQuestion("");
    }

    return (
        <div id="page-room">
            <header>
                <img src={logoImg} alt="Logo letmeask"/>
                <div>
                    <button onClick={copyRoomCodeToClipboard}>
                        <img src={copySimbol} alt="Símbolo de cópia"/>
                        <div>{params.id}</div>
                    </button>
                </div>
            </header>
            <body>
                <div>
                    <h1>Sala {title}</h1>
                    <div id="titulo">{numberOfQuestions} pergunta(s)</div>
                </div>
                <form onSubmit={handleNewQuestion}>
                    <textarea 
                        onChange={event => setNewQuestion(event.target.value)}
                        placeholder="O que você quer perguntar?"
                        value={newQuestion}
                    />
                    <div>
                        { user ? (
                            <div className="user-info">
                                <img src={user.avatar} alt={user.name} />
                                <span>{user.name}</span>
                            </div>
                        ) : (
                            <h3>Para enviar uma pergunta, <button>faça seu login.</button></h3>
                        )}
                        <Button>Enviar pergunta</Button>
                    </div>
                </form>
                {
                    questions.map(Question => {
                        return (
                            <Questions
                                key={Question.id}
                                content={Question.content}
                                author={Question.author}
                                roomId = {roomId}
                                chave={Question.id}
                                likeCount={Question.likeCount}
                                hasLiked={Question.hasLiked}
                                admin={false}
                            ></Questions>
                        )
                    })
                }
            </body>
        </div>
    );
}